"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ChatLists = void 0;
require("antd/lib/divider/style");
var _divider = _interopRequireDefault(require("antd/lib/divider"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _classnames = _interopRequireDefault(require("classnames"));
var _ChatPreview = _interopRequireDefault(require("./ChatPreview"));
var _utils = require("../../../utils");
var _lodash = require("lodash");
var _ = require("../..");
var _utils2 = require("../utils");
var _reactRouterDom = require("react-router-dom");
var _StaticChatPreview = _interopRequireDefault(require("./StaticChannelLayouts/StaticChatPreview"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
// member_count: -1 apply for community channels to be always rendered
// we have all the patients included there so member_count would be the greatest for them
var DEFAULT_CHANNELS_SORT = [{
  member_count: -1
}, {
  last_message_at: -1
}];
var Paragraph = _typography.default.Paragraph,
  Title = _typography.default.Title;
var ALL_COMMUNITY_CHANNEL_TYPES = [].concat(_toConsumableArray((0, _lodash.values)(_utils.COMMUNITY_CHANNEL_TYPES)), _toConsumableArray((0, _lodash.values)(_utils.SUPPORT_GROUP_CHANNEL_TYPES)), _toConsumableArray((0, _lodash.values)(_utils.MEMBER_RESTRICTED_CHANNEL_TYPES)));
var ChatList = function ChatList(_ref) {
  var title = _ref.title,
    children = _ref.children,
    sort = _ref.sort,
    staticChannelPreviews = _ref.staticChannelPreviews;
  var channelPreviews = (0, _react.useMemo)(function () {
    if (!sort) {
      return children;
    }
    return (0, _lodash.sortBy)(children, function (el) {
      return sort(el.props.channel);
    });
  }, [children, sort]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "chat-list"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "chat-list-header"
  }, /*#__PURE__*/_react.default.createElement(Paragraph, null, title)), staticChannelPreviews, channelPreviews, /*#__PURE__*/_react.default.createElement(_divider.default, null));
};
var ChatLists = function ChatLists(_ref2) {
  var children = _ref2.children,
    _ref2$error = _ref2.error,
    error = _ref2$error === void 0 ? false : _ref2$error,
    loading = _ref2.loading,
    onChannelSelect = _ref2.onChannelSelect,
    StaticChatPreview = _ref2.StaticChatPreview;
  var _children$props = children.props,
    chatPreviewElements = _children$props.children,
    hasNextPage = _children$props.hasNextPage,
    loadNextPage = _children$props.loadNextPage,
    refreshing = _children$props.refreshing;
  var _useCommunityChannels = (0, _utils2.useCommunityChannelsElementsLists)(chatPreviewElements),
    gettingStartedChatsElements = _useCommunityChannels.gettingStartedChatsElements,
    groupChatsElements = _useCommunityChannels.groupChatsElements,
    conversationsChatsElements = _useCommunityChannels.conversationsChatsElements,
    emergencyResourcesChatElement = _useCommunityChannels.emergencyResourcesChatElement;
  var _useCommunityStaticEl = (0, _utils2.useCommunityStaticElementsLists)(StaticChatPreview, onChannelSelect),
    gettingStartedStaticElements = _useCommunityStaticEl.gettingStartedStaticElements,
    groupChatsStaticElements = _useCommunityStaticEl.groupChatsStaticElements;
  var channelSort = (0, _react.useCallback)(function (channel) {
    return channel.data.order;
  }, []);
  if (error) {
    return /*#__PURE__*/_react.default.createElement(_streamChatReact.ChatDown, {
      type: "Connection Error"
    });
  }
  if (loading) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__channel-list-team"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__channel-list-team__main"
  }, /*#__PURE__*/_react.default.createElement(ChatList, {
    title: "Getting Started",
    sort: channelSort,
    staticChannelPreviews: gettingStartedStaticElements
  }, gettingStartedChatsElements), /*#__PURE__*/_react.default.createElement(ChatList, {
    title: "Support group channels",
    staticChannelPreviews: groupChatsStaticElements
  }, groupChatsElements), hasNextPage && /*#__PURE__*/_react.default.createElement(_streamChatReact.LoadMoreButton, {
    onClick: loadNextPage,
    refreshing: refreshing
  }), /*#__PURE__*/_react.default.createElement(ChatList, {
    title: "Conversations",
    sort: channelSort
  }, conversationsChatsElements), /*#__PURE__*/_react.default.createElement(ChatList, null, emergencyResourcesChatElement)));
};
exports.ChatLists = ChatLists;
var ChannelList = function ChannelList(props) {
  var activeChannelId = props.activeChannelId,
    menuOpen = props.menuOpen,
    setMenuOpen = props.setMenuOpen,
    _props$Preview = props.Preview,
    Preview = _props$Preview === void 0 ? _ChatPreview.default : _props$Preview,
    _props$title = props.title,
    title = _props$title === void 0 ? 'Monument community' : _props$title,
    leaveChat = props.leaveChat,
    leavingChat = props.leavingChat,
    onRemovedFromChannel = props.onRemovedFromChannel,
    _props$filters = props.filters,
    filters = _props$filters === void 0 ? {
      type: {
        $in: ALL_COMMUNITY_CHANNEL_TYPES
      },
      disabled: false
    } : _props$filters,
    _props$channelRenderF = props.channelRenderFilterFn,
    channelRenderFilterFn = _props$channelRenderF === void 0 ? function (channels) {
      return channels.filter(function (_ref3) {
        var type = _ref3.type;
        return ALL_COMMUNITY_CHANNEL_TYPES.includes(type);
      });
    } : _props$channelRenderF,
    _props$StaticChatPrev = props.StaticChatPreview,
    StaticChatPreview = _props$StaticChatPrev === void 0 ? _StaticChatPreview.default : _props$StaticChatPrev;
  var _useCustomChatContext = (0, _utils2.useCustomChatContext)(),
    customChannel = _useCustomChatContext.customChannel,
    baseUrl = _useCustomChatContext.baseUrl;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    menuInitiallyOpen = _useState2[0],
    setMenuInitiallyOpen = _useState2[1];
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    channel = _useChatContext.channel,
    navOpen = _useChatContext.navOpen,
    openMobileNav = _useChatContext.openMobileNav;
  var sortFromQueryString = (0, _utils.useChannelSortOptionsFromQueryString)();
  var sortChannels = (0, _react.useMemo)(function () {
    return [].concat(_toConsumableArray(sortFromQueryString), DEFAULT_CHANNELS_SORT);
  }, [sortFromQueryString]);
  var history = (0, _reactRouterDom.useHistory)();
  (0, _react.useEffect)(function () {
    if (!activeChannelId && !menuInitiallyOpen && channel && !navOpen) {
      openMobileNav();
      setMenuInitiallyOpen(true);
      setMenuOpen(true);
    }
  }, [navOpen, channel]);

  // We use pathname as a source of truth to set active channel in useCommunityChannelsHistory hook
  var onChannelSelect = function onChannelSelect(channel) {
    setMenuOpen(false);
    history.push("".concat(baseUrl, "/").concat(channel === null || channel === void 0 ? void 0 : channel.id));
  };

  // wrapping in useMemo here is important to avoid stream chat rerenders
  // and issue with disappearing DynamicHeightCubby
  // React.memo is not the option
  var ChatPreview = (0, _react.useMemo)(function () {
    return function (props) {
      return /*#__PURE__*/_react.default.createElement(Preview, _extends({}, props, {
        leaveChat: leaveChat,
        leavingChat: leavingChat,
        onSelect: function onSelect() {
          return onChannelSelect(props.channel);
        }
      }));
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('channel-list', {
      'channel-list--open': menuOpen
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-list-container"
  }, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-list-container--header"
  }, /*#__PURE__*/_react.default.createElement(Title, {
    level: 4
  }, title), /*#__PURE__*/_react.default.createElement(_divider.default, null)), /*#__PURE__*/_react.default.createElement(_streamChatReact.ChannelList, _extends({}, props, {
    customActiveChannel: customChannel !== null && customChannel !== void 0 && customChannel.staticChannelId ? undefined : activeChannelId
    // we rewrite handler to avoid removing community chat from the list when leave it
    ,
    onRemovedFromChannel: onRemovedFromChannel,
    List: function List(props) {
      return /*#__PURE__*/_react.default.createElement(ChatLists, _extends({}, props, {
        onChannelSelect: onChannelSelect,
        StaticChatPreview: StaticChatPreview
      }));
    },
    Preview: ChatPreview,
    filters: filters,
    sort: sortChannels,
    options: {
      watch: true,
      state: true,
      message_limit: 100
    },
    channelRenderFilterFn: channelRenderFilterFn
  }))));
};
var _default = ChannelList;
exports.default = _default;